import React, { useEffect, useMemo, useState } from "react";
import infoIcon from "../../../../assets/Icons/information.svg";
import ChatList from "../../../../Chat/ChatList";
import { Outlet, useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";


export default function SellerMessagesPage() {
const router = useLocation();

  return (
    <div className="pb-6 pt-4 md:pt-6">
      <header className="mb-4 md:mb-6">
        <h1 className="my-0 text-[22px] font-semibold tracking-tight text-[#151515] md:text-[24px]">
          Messages
        </h1>
        <p className="my-0 mt-1.5 max-w-2xl text-[13px] leading-relaxed text-[#6B7280]">
          Chat with buyers about orders and products.
        </p>
      </header>

      <div className="flex min-h-[min(720px,calc(100dvh-12rem))] flex-col overflow-hidden rounded-[14px] border border-[#EFEFEF] bg-white shadow-[0_1px_3px_rgba(15,23,42,0.04)] lg:flex-row lg:items-stretch">
      <div className="flex h-full">
              {/* Conversation List Sidebar */}
              <div
                style={{ borderRight: "0.5px solid #E5E0DC" }}
                className="w-full max-w-sm  flex flex-col "
              >
                <div className="p-6 px-0 border-b border-border">
                  <ChatList />
                </div>
              </div>

                {/* CHAT CONTAINER */}
            <div className="flex-1 hidden flex-col md:flex">
              {router.pathname !== "/chat" ? (
                <>
                  <Outlet />
                </>
              ) : (
                <>
                  <Box
                    sx={{
                      bgcolor: "#F8F7F7",
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        bgcolor: "#fff",
                        width: "45%",
                        borderRadius: "10px",
                        p: 2,
                      }}
                    >
                      <img src={infoIcon} alt="info" />
                      <Box sx={{ mt: 1 }}>
                        <Typography sx={{ fontSize: "12px", color: "#000" }}>
                          Mamaket strictly prohibits any actions of offsite
                          trading, please refer to this guide
                        </Typography>
                        <ol>
                          <li>
                            <Typography
                              sx={{ fontSize: "12px", color: "#000" }}
                            >
                              {" "}
                              Transaction made outside Mamaket is not protected
                              under Protection. Do not take the risk.
                            </Typography>
                          </li>
                          <li>
                            <Typography
                              sx={{ fontSize: "12px", color: "#000" }}
                            >
                              {" "}
                              All communication and correspondence between the
                              seller and the buyer must be done through the
                              Mamaket Chat Application.
                            </Typography>
                          </li>
                          <li>
                            <Typography
                              sx={{ fontSize: "12px", color: "#000" }}
                            >
                              {" "}
                              Seller is not allowed to provide offsite trade
                            </Typography>
                          </li>
                          <li>
                            <Typography
                              sx={{ fontSize: "12px", color: "#000" }}
                            >
                              {" "}
                              All the chat record out of Mamaket will not be
                              accepted as evidence for any of the dispute or
                              claim!
                            </Typography>
                          </li>
                        </ol>
                      </Box>
                    </Box>
                  </Box>
                </>
              )}
            </div>
            </div>
      </div>
    </div>
  );
}
